<template>
<div id="home">

    <div class="hero-container">
        <div class="home-hero" :style="'background-image: url('+ require('@/assets/images/hero-4.jpg') +');'"></div>
        <div class="px-5">
            <div class="row">
                <div class="col-12 col-lg-4 mt-5"><span class="inline-title">Home Solutions</span> is a Canberra based design team specialising in residential projects of all sizes. Our team has extensive experience in designing New Homes, Extensions, Renovations and Multi-residential projects.</div>
                <div class="col-12 col-lg-4 mt-5">Our service focuses on producing high quality drawings from the initial concept through to complete detailed plans. We would love to be involved in your project. Please contact us to discuss your ideas with our designers.</div>
                <div class="col-12 col-lg-4 mt-5 d-flex justify-content-start justify-content-lg-center">
                    <strong style="display: contents;">Office:</strong> 46 Sheppard St, Hume ACT 2620 <br>
                    <strong style="display: contents;">Phone:</strong> <a style="display:contents;" href="tel:0262601042"> (02) 6260 1042</a> <br>
                    <strong style="display: contents;">Email:</strong> <a style="display:contents;" href="mailto:info@hsol.com.au">info@hsol.com.au</a>
                </div>
            </div>
        </div>
    </div>

    <div id="services" class="row border-alt-b border-alt-t mt-5 pt-5 pb-5">
        <div class="col-12 pb-0 pb-md-8">
            <div class="row">
                <div id="residential" class="services-text col-12 pb-5 px-5 col-lg-6 pb-lg-0 pr-lg-5 col-xl-5 offset-xl-1">
                    <img src="@/assets/images/newhomedesign.jpg" width="100%" class="img-fluid mb-3" alt="Responsive image"/>
                    <h4 class="services-title">NEW HOME DESIGN</h4>
                    <p>If you are looking to design a new home or do a knock-down rebuild, we have an experienced team to guide you through the design process right from the initial meeting to the finished product.</p>
                    <p>A new home is a great opportunity to design around your lifestyle.</p>
                </div>
                <div id="renovations" class="services-text col-12 px-5 pl-lg-5 col-lg-6 col-xl-5">
                    <img src="@/assets/images/renovations.jpg" width="100%" class="img-fluid mb-3" alt="Responsive image"/>
                    <h4 class="services-title">RENOVATIONS &amp; EXTENSIONS</h4>
                    <p>Small renovations to major extensions and remodelling.</p>
                    <p>Renovations and extensions can transform your home. These projects require thoughtful design, careful planning and development in order to achieve the best possible outcome. Even a small alteration can have a large impact.</p>
                </div>
            </div>
        </div>
        <div class="col-12">
            <div class="row">
                <div id="multiresidential" class="services-text col-12 pb-5 px-5 col-lg-6 pb-lg-0 pr-lg-5 col-xl-5 offset-xl-1">
                    <img src="@/assets/images/multiresidential.jpg" width="100%" class="img-fluid mb-3" alt="Responsive image"/>
                    <h4 class="services-title">MULTI RESIDENTIAL</h4>
                    <p>Our team is knowledgeable and experienced across all multi-residential projects. These include dual occupancies, multiple units and secondary residences. Our understanding of the rules and regulations, paired with creative design, will maximise the potential of your property.</p>
                </div>
                <div id="rendering" class="services-text col-12 px-5 pl-lg-5 col-lg-6 col-xl-5">
                    <img src="@/assets/images/rendering.jpg" width="100%" class="img-fluid mb-3" alt="Responsive image"/>
                    <h4 class="services-title">3D RENDERING</h4>
                    <p>3D renderings provide appealing representations of your project. Great for advertising and as a marketing tool for your business. We can also customise a package which includes a combination of renders and floor plans to best suit your requirements.</p>
                </div>
            </div>
        </div>
    </div>

    <div class="border-alt-b">
        <div class="col-12 col-xl-8 offset-xl-2">
            <div class="row">
                <div class="col-12 col-lg-6 p-5 pt-lg-5">
                    <img src="@/assets/images/about.jpg" width="100%" height="50%" class="img-fluid about-img mobile-center" style="max-width: 1000px" alt="Responsive image"/>
                </div>
                <div class="col-12 col-lg-6 p-5 pt-lg-5">
                        <h4>ABOUT US</h4>
                        <p>Home Solutions is your premium design service in Canberra</p>
                        <p>Our team has extensive experience in New Homes, Extensions, Renovations and Multi-residential projects.</p>
                        <p>We will work closely with you to deliver the home you want. See your project before it's built with our superb 3D imaging.</p>
                        <p>We have a unique relationship with many manufacturing companies and building suppliers. This gives us direct access to the latest building products and construction details.</p>
                        <p>At Home Solutions, we pride ourselves on delivering high quality design and documentation services.</p>
                        <p>We look forward to working with you.</p>
                </div>
            </div>
        </div>
    </div>
    <div class="border-alt-b">
        <div class="p-5">
            <div class="row">
                <div class="col-12 col-lg-6 col-xl-5 offset-xl-1 col-md-6 line-height">
                    <h5>HOME SOLUTIONS DESIGN GROUP</h5>
                    <br />
                    <h6>ADDRESS</h6>
                    <p>46 Sheppard Street<br/>Hume, ACT, 2620</p>
                    <br />
                    <h6>PHONE</h6>
                    <p><a class="text-dark" href="tel:0262601042">02 6260 1042</a></p>
                    <br>
                    <h6>EMAIL</h6>
                    <p><a class="text-dark" href="mailto:info@hsol.com.au">info@hsol.com.au</a></p>
                    <br />
                    <h6>CONNECT WITH US</h6>
                    <p><a class="text-dark" href="https://www.facebook.com/Home-Solutions-118413178233036/" target="_blank">
                        <i class="fab fa-facebook-square text-black ml-2"></i> Facebook</a>
                    </p>
                </div>
                <div class="col-12 col-md-6 col-xl-5 mt-2 mt-md-0">
                    <div>
                        <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3252.6662195005674!2d149.16624731631603!3d-35.38873360696408!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6b164bb75f314559%3A0x202919334e8b48d6!2sHome+solutions+architecture!5e0!3m2!1sen!2sau!4v1527139765473" width="100%" height="350" frameborder="0" style="border:0" allowfullscreen></iframe>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="border-alt-b bg-alt-darkgrey py-8 px-3">
        <div class="page container">
            <div class="row center pb-3">
                <h3 class="text-white">Talk with Us</h3>
            </div>
            <div class="row">
                <div class="col-12 col-sm-10 offset-sm-1 col-md-8 offset-md-2 col-lg-4 offset-lg-4">
                    <talk-with-us></talk-with-us>
                </div>
            </div>
        </div>
    </div>
</div>

</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import Hero from './home/Hero'
import Newsletter from './home/Newsletter'
import TalkWithUs from './home/TalkWithUs'

export default {
	name: 'home',
	data() {
		return {
			//
		}
	},
	components: {
		Hero,
		Newsletter,
		TalkWithUs
	},
	methods: {
		//
	},
	computed: {
		//
	},
	mounted() {
		console.log('Home Mounted')
	}
}
</script>

<style>
.hero-container {
	display: flex;
	margin-top: 60px;
	flex-direction: column;
}
.home-hero {
	height: 250px;
	background-size: cover;
	background-position: left center;
}
.section {
	height: 100vh;
	min-height: fit-content;
	display: flex;
	align-items: center;
}
@media screen and (min-width: 768px) {
	.home-hero {
		height: calc(50vh);
	}
}
@media screen and (min-width: 991px) {
	.hero-container {
		margin-top: 0;
		height: 98vh;
	}
	.home-hero {
		height: 100vh;
	}
}
</style>


// WEBPACK FOOTER //
// src/components/Home.vue